import { cn } from '../../lib/cn'

/** The product mark: a double-ruled square, like the company stamp it takes its colour from. */
export function StampMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('shrink-0 text-stamp', className)}>
      <rect x="2" y="2" width="28" height="28" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="6" y="6" width="20" height="20" rx="1" fill="none" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M11 20.5c1.2 1 2.8 1.5 4.6 1.5 2.9 0 4.4-1.3 4.4-3.1 0-4-8.6-2.4-8.6-6.1 0-1.6 1.4-2.8 3.9-2.8 1.5 0 2.9.4 3.9 1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="square"
      />
    </svg>
  )
}

/** "سحاب Sahab" in Reem Kufi — with the page title, the only use of the display face. */
export function Wordmark({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <span data-slot="wordmark" className={cn('flex items-center gap-2 font-display text-ink', className)}>
      <StampMark className="size-6" />
      {compact ? null : (
        <span className="flex items-baseline gap-1.5 text-2xl leading-8 font-medium" translate="no">
          <span lang="ar">سحاب</span>
          <span lang="en" className="text-lg text-ink-muted">
            Sahab
          </span>
        </span>
      )}
    </span>
  )
}
